module.exports = new __parcel__URL__("project-issue-navigator-skeleton.tpl.2a1718d8.svg").toString();